import { Injectable } from '@angular/core';
import { DocumentsApiService } from '@epicuro-next/data/documents';
import { selectActiveAccountId } from '@epicuro-next/state/accounts-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

import {
  loadUserAgreement,
  loadUserAgreementFailure,
  loadUserAgreementSuccess,
} from '../actions';

@Injectable()
export class UserAgreementEffects {
  constructor(
    private actions$: Actions,
    private documentsApi: DocumentsApiService,
    private store: Store,
  ) {}

  public loadUserAgreement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserAgreement),
      withLatestFrom(
        this.store.pipe(select(selectActiveAccountId), filter(isNonNullish)),
      ),
      switchMap(([, activeAccountId]) =>
        this.documentsApi.getAccountDocuments(activeAccountId).pipe(
          map(DocumentsApiService.SortNewestFirst),
          map((documents) => loadUserAgreementSuccess({ documents })),
          catchError(() => of(loadUserAgreementFailure)),
        ),
      ),
    ),
  );
}
